import { render, staticRenderFns } from "./APILoading.vue?vue&type=template&id=18a91643&scoped=true&"
import script from "./APILoading.vue?vue&type=script&lang=js&"
export * from "./APILoading.vue?vue&type=script&lang=js&"
import style0 from "./APILoading.vue?vue&type=style&index=0&id=18a91643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a91643",
  null
  
)

export default component.exports